import * as yup from "yup";

export const michiganStateFormSchema = yup.object().shape({
    personalAndDependentExemptions: yup.number(),
    additionalAmountDeductedFromEachPay: yup.number(),
    claimExemption: yup.string(),
    wagesAreExemptExplanation: yup.string(),
    permanentHomeRenaissanceZone: yup.string(),
});
